import IcShield from 'assets/images/backoffice/capital/ic-shield.svg';
import React from 'react';
import ListItem from '../ListItem';
import InfoCard from './InfoCard';
import styles from './InfoCard.css';

function WhyCapital() {
  return (
    <InfoCard
      title="Mengapa Moka Capital?"
      icon={<img src={IcShield} className={styles.shield} />}
    >
      <div className={styles['wrapper-why-capital']}>
        <ListItem>Proses pengajuan praktis</ListItem>
        <ListItem>
          Data dijamin aman dan partner terdaftar dan diawasi oleh OJK
        </ListItem>
        <ListItem>Tanpa agunan</ListItem>
      </div>
    </InfoCard>
  );
}

export default WhyCapital;
